import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
// import * as ngxImageCropper from "ngx-image-cropper";
import { WebcamImage, WebcamInitError, WebcamUtil } from "ngx-webcam";
import { Observable, Subject } from "rxjs";
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: "app-add-pettyCash-image",
    templateUrl: "./add-pettyCash-image.component.html",
    styleUrls: ["./add-pettyCash-image.component.css"],
})
export class AddPettyCashImageComponent implements OnInit {
    @Input() public  popupType: any;
    @Input() public  memberObj: any;
    @Output() public  closeThePopup = new EventEmitter<any>();
    @Output() public  outputImage = new EventEmitter<any>();
    name = "Angular";
    currentStep: number = 1;
    imageChangedEvent: any = "";
    croppedImage: any = "";
    imageWidth: number;
    imageHeight: number;
    imageSize: number;
    public multipleWebcamsAvailable = false;
    public allowCameraSwitch = true;
    public showWebcam = true;
    // public deviceId: string;
    public videoOptions: MediaTrackConstraints = {
        // width: {ideal: 1024},
        // height: {ideal: 576}
    };
    public errors: WebcamInitError[] = [];
    index: number = 0;

    // webcam snapshot trigger
    private trigger: Subject<void> = new Subject<void>();
    // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
    private nextWebcam: Subject<boolean | string> = new Subject<
        boolean | string
    >();

    // latest snapshot
    public webcamImage: WebcamImage = null;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.currentStep = 1;
        WebcamUtil.getAvailableVideoInputs().then(
            (mediaDevices: MediaDeviceInfo[]) => {
                this.multipleWebcamsAvailable =
                    mediaDevices && mediaDevices.length > 1;
            }
        );
    }

    triggerSnapshot(): void {
        this.index = 1;
        this.trigger.next();
        this.currentStep++;
    }

    get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }

    get nextWebcamObservable(): Observable<boolean | string> {
        return this.nextWebcam.asObservable();
    }

    // cameraWasSwitched(deviceId: string): void {
    //     this.deviceId = deviceId;
    // }

    // handleInitError(error: WebcamInitError): void {
    //     this.errors.push(error);
    // }

    // handleImage(webcamImage: WebcamImage): void {
    //     // this.pictureTaken.emit(webcamImage);
    //     this.webcamImage = webcamImage;
    // }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
        this.currentStep++;
    }
    imageCropped(event: any) {
        this.croppedImage = event.base64;
    }

    closePopup() {
        this.closeThePopup.emit("");
    }

    resetAll() {
        this.currentStep = 1;
        this.imageChangedEvent = "";
        this.croppedImage = "";
    }

    next() {
        this.currentStep++;
        const blob = this.dataURItoBlob(this.croppedImage);
        this.calculateImageInfo(blob);
    }

    finish() {
        this.outputImage.emit(this.croppedImage);
    }
    
    calculateImageInfo(blob: Blob) {
        const reader = new FileReader();
      
        reader.onload = () => {
          const image = new Image();
      
          image.onload = () => {
            this.imageWidth = image.width;
            this.imageHeight = image.height;
            const imageSizeInBytes = blob.size;
            this.imageSize = Math.round(imageSizeInBytes / 1024);

            this.cdr.detectChanges();
      
            console.log('Image Width:', this.imageWidth);
            console.log('Image Height:', this.imageHeight);
            console.log('Image Size (KB):', this.imageSize);
          };
      
          image.onerror = () => {
            console.error('Failed to load the image.');
          };
      
          image.src = URL.createObjectURL(blob);
        };
      
        reader.onerror = () => {
          console.error('Error reading the Blob.');
        };
      
        reader.readAsDataURL(blob);
      }

      dataURItoBlob(dataURI: string): Blob {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      
        const byteArray = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
          byteArray[i] = byteString.charCodeAt(i);
        }
      
        return new Blob([byteArray], { type: mimeString });
      }
      
      
}
